import * as yup from 'yup';

export const commonCompTeuFactorValidation: { [x: string]: any; } = {
    teuFactor: yup.number().required("Missing.")
};

export const commonCompTeuFactorValidationSchema = yup.object().shape(commonCompTeuFactorValidation);
